import React from 'react';
import { ShoppingCartIcon, UserIcon } from 'lucide-react';
import { mockRD } from '../data/mockData';
import { Logo } from './Logo';
interface HeaderProps {
  cartCount: number;
  onCartClick: () => void;
  onProfileClick: () => void;
}
export function Header({
  cartCount,
  onCartClick,
  onProfileClick
}: HeaderProps) {
  return <header className="sticky top-0 z-50 bg-white border-b border-gray-200 px-4 py-3" data-id="element-34">
      <div className="flex items-center justify-between max-w-lg mx-auto" data-id="element-35">
        <Logo data-id="element-36" />

        <div className="flex items-center gap-3" data-id="element-37">
          <button onClick={onCartClick} className="relative p-2 hover:bg-gray-100 rounded-full transition-colors" aria-label="Shopping cart" data-id="element-38">
            <ShoppingCartIcon className="w-6 h-6 text-gray-700" data-id="element-39" />
            {cartCount > 0 && <span className="absolute -top-1 -right-1 bg-pink-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center" data-id="element-40">
                {cartCount}
              </span>}
          </button>

          <div className="flex items-center gap-2" data-id="element-41">
            <img src={mockRD.avatar} alt={mockRD.name} className="w-8 h-8 rounded-full object-cover border-2 border-green-400" data-id="element-42" />
            <div className="hidden sm:block" data-id="element-43">
              <p className="text-xs font-semibold text-gray-900 leading-tight" data-id="element-44">
                {mockRD.name}
              </p>
              <p className="text-xs text-gray-500 leading-tight" data-id="element-45">
                {mockRD.credentials}
              </p>
            </div>
          </div>

          <button onClick={onProfileClick} className="p-2 hover:bg-gray-100 rounded-full transition-colors" aria-label="Profile" data-id="element-46">
            <UserIcon className="w-6 h-6 text-gray-700" data-id="element-47" />
          </button>
        </div>
      </div>
    </header>;
}